/* eslint-disable no-new */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'teld-web-component/css/base.css'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import 'flex.css'
import 'assets/css/common/common.scss'
import 'swiper/dist/css/swiper.css'
import './utils/rem.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'babel-polyfill'

Vue.use(VueAwesomeSwiper)
Vue.use(iView)
Vue.use(router)

Vue.config.productionTip = false
/* 在路由跳转后的页面的滚动条在顶端 */
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js